// extracted by mini-css-extract-plugin
module.exports = {"container":"Documents_container__Fp_CI","paper":"Documents_paper__pSh9j","title":"Documents_title__flRXX","item":"Documents_item__rSiAn"};